let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("gZdcf")).then(() => parcelRequire('kJZys'));